export default __webpack_public_path__ + "static/media/img5.22481c09.png";